import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { altTextTreeAtom, exportDataAtom, exportOptionsAtom } from './atoms'
import { exportCsv } from 'shared/utils'
import { ConfirmWithDialogButton } from 'shared/ui'
import { Box, Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'

export function ExportButton() {
  const { tree } = useAtomValue(altTextTreeAtom)
  const altTextData = useAtomValue(exportDataAtom)

  const doExport = () => {
    exportCsv(
      [altTextData.headers, ...altTextData.data],
      `AltText-${tree?.title}`,
    )
  }

  return (
    <ConfirmWithDialogButton
      dialogTitle="Export CSV"
      dialogContent={<ExportOptions />}
      onClick={doExport}
    >
      Export CSV
    </ConfirmWithDialogButton>
  )
}

function ExportOptions() {
  const [options, setOptions] = useAtom(exportOptionsAtom)

  return (
    <Box>
      <Box>Export Options</Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={options.excludeWithoutAltText}
            onChange={({ target: { checked } }) =>
              setOptions((prev) => ({
                ...prev,
                excludeWithoutAltText: checked,
              }))
            }
            name="is_verified"
          />
        }
        label="Exclude Without Alt Text"
      />
    </Box>
  )
}
